/**
 * SHIM for @mui/utils/useId
 * Avoids early access to React internals and provides a safe fallback.
 */
import { useId as reactUseId, useRef } from 'react';

const useId: () => string = () => {
  if (typeof reactUseId === 'function') {
    return reactUseId();
  }
  const ref = useRef<string | null>(null);
  if (ref.current == null) {
    // Non-crypto simple unique-ish id for fallback
    ref.current = `uid_${Math.random().toString(36).slice(2, 10)}`;
  }
  return ref.current;
};

export default useId;
